export const setUser = user => ({
    type: 'CHANGE_USER',
    user: user
});

export const logout = () => ({
    type: 'CHANGE_USER',
    user: null,
});


// WEBPACK FOOTER //
// ./src/actions/user.js